import React from "react";

export const Supervisior = React.memo(function Supervisior() {
    return (
        <li className={"super_visor"}>
            <p className={"super_visor_title"}>監修</p>
            <div className={"super_visor_name"}>
                <p>{"藤田医科大学 連携地域医療学 准教授"}</p>
                <p>{"大杉 泰弘"}</p>
            </div>
        </li>
    );
});